// extracted by mini-css-extract-plugin
export default {"title":"CTABanner_title__e1vwG","pitstopGif":"CTABanner_pitstopGif__W6lbC"};